var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    fill: "#858199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/day"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62499999,16.375 L11.375,16.375 C11.71875,16.375 12,16.09375 12,15.75 L12,12 C12,11.65625 11.71875,11.375 11.375,11.375 L7.62499999,11.375 C7.28124999,11.375 6.99999999,11.65625 6.99999999,12 L6.99999999,15.75 C6.99999999,16.09375 7.28124999,16.375 7.62499999,16.375 Z M18.875,4.49999997 L17,4.49999997 L17,2.62499998 C17,2.28124998 16.71875,1.99999997 16.375,1.99999997 L15.125,1.99999997 C14.78125,1.99999997 14.5,2.28124998 14.5,2.62499998 L14.5,4.49999997 L9.49999999,4.49999997 L9.49999999,2.62499998 C9.49999999,2.28124998 9.21874999,1.99999997 8.87499999,1.99999997 L7.62499999,1.99999997 C7.28124999,1.99999997 6.99999999,2.28124998 6.99999999,2.62499998 L6.99999999,4.49999997 L5.12499998,4.49999997 C4.08984373,4.49999997 3.24999998,5.33984373 3.24999998,6.37499999 L3.24999998,20.125 C3.24999998,21.1601563 4.08984373,22 5.12499998,22 L18.875,22 C19.9101563,22 20.75,21.1601563 20.75,20.125 L20.75,6.37499999 C20.75,5.33984373 19.9101563,4.49999997 18.875,4.49999997 Z M18.875,19.890625 C18.875,20.0195313 18.7695313,20.125 18.640625,20.125 L5.35937498,20.125 C5.23046873,20.125 5.12499998,20.0195313 5.12499998,19.890625 L5.12499998,8.24999999 L18.875,8.24999999 L18.875,19.890625 Z",
    id: "calendar-day"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDay);
export default __webpack_public_path__ + "static/media/iconDay.f6992442.svg";
export { ForwardRef as ReactComponent };